import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorMsg, ErrorMsgCont, ErrorMsgIcon, FormInput, InputCont, Label } from './Input.styles';

interface IInput {
  registerPath: string;
  placeholder?: string;
  type?: string;
  label: string;
}

const Input: FC<IInput> = ({ registerPath, placeholder = '', type = 'text', label }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const isFormInputInvalid = errors[registerPath];

  return (
    <InputCont data-testid="input-container">
      <Label data-testid="input-label">{label}</Label>
      <FormInput
        className={isFormInputInvalid ? 'invalid-input' : ''}
        placeholder={placeholder}
        {...register(registerPath)}
        type={type}
        data-testid="input-field"
      />
      {isFormInputInvalid ? (
        <ErrorMsgCont data-testid="error-container">
          <ErrorMsgIcon data-testid="error-msg-icon" />
          <ErrorMsg data-testid="error-msg">{isFormInputInvalid.message as string}</ErrorMsg>
        </ErrorMsgCont>
      ) : null}
    </InputCont>
  );
};

export default Input;
